'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalHotel = function MdLocalHotel(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 11.6c3.7 0 6.8 3.1 6.8 6.8v15h-3.4v-5h-30v5h-3.4v-25h3.4v15h13.4v-11.8h13.2z m-20 10c-2.7 0-5-2.2-5-5s2.3-5 5-5 5 2.3 5 5-2.2 5-5 5z' })
        )
    );
};

exports.default = MdLocalHotel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-hotel.js
// module id = 1180
// module chunks = 36573943044255 79611799117203 213534597649335